import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import ActionTable from "../../components/table/ActionTable";
import { formatDateTime, mergeParams } from "../../helpers/helpers";

export default function FaturaPersonalizada({ history, location }) {
  const { notification } = useContext(AppContext);
  const [comboEscolas, setComboEscolas] = useState([]);
  const [escolaSelecionadaId, setEscolaSelecionadaId] = useState(0);
  const [gerandoFatura, setGerandoFatura] = useState(false);
  const [faturasEscola, setFaturasEscola] = useState(false);
  const [faturaAtiva, setFaturaAtiva] = useState(false);
  const [inclusaoAcrescimo, setInclusaoAcrescimo] = useState(false);
  const [acrescimos, setAcrescimos] = useState([]);
  const [extrato, setExtrato] = useState({});
  const [faturaGerar, setFaturaGerar] = useState({});
  const [confirmacaoGeracaoFatura, setConfirmacaoGeracaoFatura] =
    useState(false);

  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        escolaId: 0,
        mes: new Date().getMonth() + 1,
        ano: new Date().getFullYear(),
      },
      location
    )
  );

  const [dataAtual] = useState(new Date());

  useEffect(() => {
    if (filtros.escolaId > 0) {
      listarFaturasGeradas();
    }

    carregarComboEscolas();
  }, []);

  const carregarComboEscolas = () => {
    api
      .get("escolas/listar", { ativas: true })
      .then((comboEscolas) => setComboEscolas(comboEscolas))
      .catch((err) => notification("error", "Erro ao listar as escolas"));
  };

  const listarFaturasGeradas = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    api
      .get("faturas/listar", filtrosEnviar)
      .then((faturasEscola) => {
        if (faturasEscola.length === 0)
          notification(
            "warning",
            "A escola ainda não tem faturas geradas para o mês/ano."
          );

        setEscolaSelecionadaId(filtrosEnviar.escolaId);

        let faturaAtiva = false;

        faturasEscola.forEach((f) => {
          f.geracao = formatDateTime(f.geracao, "D/M/Y h:m");
          f.vencimento = formatDateTime(f.vencimento, "D/M/Y");

          f.tipo = f.avulsa ? "Avulsa" : f.parcial ? "Parcial" : "Padrão";

          if (f.cancelamento) {
            f.situacao = `Cancelada (${formatDateTime(
              f.cancelamento,
              "D/M/Y h:m"
            )})`;
          } else {
            f.situacao = f.pagamento
              ? "Pagamento registrado"
              : "Pagamento não registrado";
            if (!f.parcial) faturaAtiva = true;
          }

          f.iuguUrl = (
            <a href={f.iuguUrl} target="_blank">
              {f.iuguUrl}
            </a>
          );

          f.acoes = (
            <>
              <IconButton
                key={1}
                title={"Cancelar fatura"}
                style={{ color: "red" }}
                onClick={() => cancelarFatura(f)}
              >
                <i className="zmdi zmdi-smartphone-erase"></i>
              </IconButton>
            </>
          );
        });

        setFaturasEscola(faturasEscola);
        setFaturaAtiva(faturaAtiva);
        carregarExtratoEscola(filtrosEnviar);
      })
      .catch((e) => {
        notification("error", "Erro ao listar as faturas geradas");
        console.log(e);
      });
  };

  const carregarExtratoEscola = (escolaFatura) => {
    api
      .get("faturas/extratoEscola", escolaFatura)
      .then((extrato) => setExtrato(extrato))
      .catch((e) => notification("error", "Erro ao carregar o extrato."));
  };

  const fFiltros = {
    title: "Fatura base",
    form: {
      escolaId: {
        label: "Escola",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        value: filtros.escolaId,
      },
      mes: {
        label: "Mês",
        type: "select",
        emptyItem: true,
        space: 3,
        array: {
          data: meses,
          value: "id",
          desc: "nome",
        },
        value: filtros.mes,
      },
      ano: {
        label: "Ano",
        type: "select",
        value: filtros.ano,
        space: 3,
        options: (() => {
          const anos = [];

          for (
            var i = dataAtual.getFullYear() - 3;
            i <= dataAtual.getFullYear();
            i++
          ) {
            anos.push({ value: i, desc: i.toString() });
          }

          return anos;
        })(),
      },
    },
    submit: {
      label: "carregar",
      action: listarFaturasGeradas,
    },
    close: true,

    urlParams: true,
    history,
    location,
  };

  const cancelarFatura = (fatura) => {
    if (fatura.cancelamento)
      return notification("warning", "Fatura já cancelada.");

    api
      .post("faturas/cancelar", { faturaId: fatura.faturaEscolaId })
      .then(() => {
        notification("warning", "Fatura cancelada.");
        listarFaturasGeradas(filtros);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Já cancelada");
          case 2:
            return notification("error", "Fatura paga");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const tFaturasEscola = {
    title: "Faturas geradas",
    array: faturasEscola,
    columns: [
      {
        name: "geracao",
        label: "Gerada em",
      },
      {
        name: "vencimento",
        label: "Vencimento",
      },
      {
        name: "iuguId",
        label: "ID da fatura na Iugu",
      },
      {
        name: "iuguUrl",
        label: "URL da fatura",
      },
      {
        name: "tipo",
        label: "Tipo",
      },
      {
        name: "situacao",
        label: "Situação",
      },
      {
        name: "acoes",
        label: "Ações",
      },
    ],
  };

  const camposExtrato = () => {
    return {
      periodo: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Período</h4>
            <p>{`${extrato.ano}/${extrato.mes}`}</p>
          </div>
        ),
      },
      total: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Valor total</h4>
            <p>{`R$ ${(extrato.valorTotalItens / 100).toFixed(2)}`}</p>
          </div>
        ),
      },
    };
  };

  const detalharExtrato = (extrato) => {
    window.open(
      `/app/faturas/fatura-escola/${extrato.escolaId}/${extrato.ano}/${extrato.mes}`,
      "_blank"
    );
  };

  const fExtratoEscola = {
    form: camposExtrato(extrato),
    title: "Extrato da escola",
    customActions: [
      {
        label: "Detalhes",
        action: () => detalharExtrato(extrato),
      },
    ],
  };

  const camposFaturaGerar = () => {
    return {
      vencimento: {
        label: "Vencimento",
        type: "date",
        required: true,
        space: 4,
        value: faturaGerar.vencimento,
      },
      desconto: {
        label: "Desconto (R$)",
        type: "number",
        space: 4,
        value: faturaGerar.desconto,
      },
      parcial: {
        label: "Parcial/fracionada",
        type: "check",
        // value: false,
        space: 2,
        value: faturaGerar.parcial,
      },
      aplicarRegrasAtraso: {
        label: "Aplicar regras de atraso",
        type: "check",
        // value: false,
        space: 2,
        value: faturaGerar.aplicarRegrasAtraso,
      },
    };
  };

  const fFaturaGerar = {
    form: camposFaturaGerar(),
    title: "Dados da nova fatura",
    submit: {
      label: "Gerar fatura",
      action: (form) => {
        setFaturaGerar(form);
        setConfirmacaoGeracaoFatura(true);
      },
    },
    // closeButton: true,
    // history: this.props.history,
  };

  const incluirAcrescimo = (acrescimo) => {
    const acrescimosAtualizar = [...acrescimos];

    acrescimosAtualizar.push(acrescimo);

    setAcrescimos(acrescimosAtualizar);
    setInclusaoAcrescimo(false);
  };

  const removerAcrescimo = (acrescimoRemover) => {
    let acrescimosAtualizar = [...acrescimos];

    acrescimosAtualizar = acrescimosAtualizar.filter(
      (a) =>
        a.descricao !== acrescimoRemover.descricao &&
        a.valor !== acrescimoRemover.valor
    );

    setAcrescimos(acrescimosAtualizar);
    setInclusaoAcrescimo(false);
  };

  const tAcrescimos = {
    title: "Acrescimos",
    array: acrescimos,
    newItemAction: () => setInclusaoAcrescimo(true),
    columns: [
      {
        name: "descricao",
        label: "Descrição",
      },
      {
        name: "valor",
        label: "Valor",
      },
    ],
    actions: [
      {
        title: "Remover acrescimo",
        action: removerAcrescimo,
        icon: "zmdi zmdi-smartphone-erase",
      },
    ],
  };

  fFaturaGerar.form.acrescimos = {
    name: "Acrescimos",
    type: "component",
    value: <ActionTable structure={tAcrescimos} />,
  };

  const camposInclusaoAcrescimo = () => {
    return {
      valor: {
        label: "Valor (R$)",
        type: "number",
        required: true,
        space: 4,
      },
      descricao: {
        label: "Descrição",
        type: "text",
        required: true,
        space: 8,
      },
    };
  };

  const fInclusaoAcrescimo = {
    form: camposInclusaoAcrescimo(),
    title: "Incluir acrescimo",
    submit: {
      label: "Salvar",
      action: incluirAcrescimo,
    },

    close: {
      label: "Cancelar",
      action: () => setInclusaoAcrescimo(false),
    },
  };

  const gerarFatura = () => {
    const dadosFaturaGerar = {
      escolaId: Number(escolaSelecionadaId),
      mes: Number(filtros.mes),
      ano: Number(filtros.ano),
      desconto: Number(faturaGerar.desconto),
      vencimento: faturaGerar.vencimento,
      parcial: faturaGerar.parcial,
      aplicarRegrasAtraso: faturaGerar.aplicarRegrasAtraso,
      acrescimos: [],
    };

    acrescimos.forEach((a) => {
      a.valor = (a.valor * 100).toFixed(0);
      dadosFaturaGerar.acrescimos.push(a);
    });

    dadosFaturaGerar.acrescimos = acrescimos;
    dadosFaturaGerar.desconto = dadosFaturaGerar.desconto
      ? (dadosFaturaGerar.desconto * 100)
      : 0;

    api
      .put("faturas/faturarPersonalizado", dadosFaturaGerar)
      .then((res) => {
        notification("success", "Fatura gerada com sucesso!");

        return history.push(
          `/app/faturas/fatura-escola/${dadosFaturaGerar.escolaId}/${dadosFaturaGerar.ano}/${dadosFaturaGerar.mes}`
        );
      })
      .catch((err) => {
        const { data } = err;
        console.log("data", data);
        switch (data[0]) {
          case 1:
            return notification("error", "Período inválido");
          case 2:
            return notification("error", "Sem pagamentos para faturar");
          case 3:
            return notification(
              "error",
              "Já existe fatura ativa para o período"
            );
          case 4:
            return notification(
              "error",
              "Erro ao gerar a fatura no ambiente IUGU"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  return (
    <div>
      {inclusaoAcrescimo ? (
        <Form formData={fInclusaoAcrescimo} />
      ) : (
        <>
          <Form formData={fFiltros} />
          {escolaSelecionadaId ? (
            <div>
              {faturaAtiva && (
                <h4 style={{ color: "red" }}>
                  Escola com fatura ativa para o mês/ano. É necessário cancelar
                  a fatura ativa antes de gerar uma nova.
                </h4>
              )}
              <ActionTable structure={tFaturasEscola} />
              <Form formData={fExtratoEscola} />
              {gerandoFatura ? (
                <CircularProgress />
              ) : faturaAtiva ? null : (
                <Form formData={fFaturaGerar} />
              )}
            </div>
          ) : (
            <h4>Para geração da fatura, informe a escola e o vencimento.</h4>
          )}
        </>
      )}

      <Dialog open={confirmacaoGeracaoFatura}>
        <DialogTitle id="scroll-dialog-title">
          Gerar fatura personalizada
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            Confirma a geração da fatura personalizada? Qualquer fatura gerada
            anteriormente será cancelada (exceto faturas parciais).
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => setConfirmacaoGeracaoFatura(false)}
          >
            Cancelar
          </Button>
          <Button variant="contained" onClick={() => gerarFatura()}>
            Concluir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const meses = [
  { id: "1", nome: "Janeiro" },
  { id: "2", nome: "Fevereiro" },
  { id: "3", nome: "Março" },
  { id: "4", nome: "Abril" },
  { id: "5", nome: "Maio" },
  { id: "6", nome: "Junho" },
  { id: "7", nome: "Julho" },
  { id: "8", nome: "Agosto" },
  { id: "9", nome: "Setembro" },
  { id: "10", nome: "Outubro" },
  { id: "11", nome: "Novembro" },
  { id: "12", nome: "Dezembro" },
];
